import { AbstractApi } from '@/api/AbstractApi'
import { AddBookContent } from '@/model/book/AddBookContent'
import request from '@/api/request'

class BookApi extends AbstractApi {
  async addAuthor(authorSlug: string, bookSlug: string, position: number) {
    const route = this.generateAdminRoute({ bookSlug, suffix: 'add-author' })

    return request.put(route, { authorSlug, position })
  }

  async addContent(content: AddBookContent, bookSlug: string) {
    const route = this.generateAdminRoute({ bookSlug, suffix: 'contents' })

    return request.put(route, content, true)
  }

  async hide(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'hide' })

    return request.put(route, { isShown: false })
  }

  async removeAuthor(authorUuid: string, bookSlug: string) {
    const route = this.generateAdminRoute({ bookSlug, suffix: 'remove-author', authorUuid })

    return request.delete(route)
  }

  async show(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'show' })

    return request.put(route, { isShown: true })
  }

  async showAuthors(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'authors' })

    return request.get(route)
  }

  async showContents(slug: string) {
    const route = this.generateAdminRoute({ slug, suffix: 'contents' })

    return request.get(route)
  }

  async updateAuthorPosition(authorSlug: string, bookSlug: string, position: number) {
    const route = this.generateAdminRoute({ slug: bookSlug, suffix: 'author-position' })

    return request.put(route, { authorSlug, position })
  }
}

export default new BookApi('book')
